import { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { POST_SELECTED_WHEN } from "../../store/action";
import { t } from "../../translations";
import { saveLocationToSession } from "../../utils/locationUtils";
import { dayPlusOne, todayDate } from "../functions/dateFunctions";
import "../styles/layout.css";

// image importation

import { configureCrisp } from "../../utils/crispConfig";
import { createLogger } from "../../utils/logger";
import SearchBar from "../elements/search-bar";
import SectionMore from "../elements/section-more";
import SectionWorking from "../elements/section-working";
import SlideImage from "../elements/slide-image";

const logger = createLogger("LayoutHome");

const Layout = () => {
  const history = useHistory();

  let selectedWhen = useSelector((state) => state.selectedWhen);
  let selectedLang = useSelector((state) => state.lang);

  const dispatch = useDispatch();

  const WhenDate = useCallback((value) => {
    dispatch(post_selected_when(value));
  }, [dispatch]);

  const initialData = useCallback(async () => {
    if (!selectedWhen || selectedWhen <= todayDate()) {
      const tday = dayPlusOne();
      WhenDate(tday);
    }
  }, [selectedWhen, WhenDate]);

  useEffect(() => {
    const initializeCrisp = async () => {
      try {
        await configureCrisp({
          autoload: true,
          lockMaximized: false,
          lockFullview: false
        });
      } catch (error) {
        // Crisp initialization is optional, log and continue
        console.warn('Failed to initialize Crisp chat:', error);
      }
    };
    
    initializeCrisp();
    initialData();
  }, [initialData]);

  return (
    <div className="global-block">
      <div className="full-block">
        <SearchBar
          placeholder={t("layout.search_placeholder", selectedLang)}
          text_btn={t("layout.find_dishes_button", selectedLang)}
          setAddress={(address, coordinates, metropolitan_area) => {
            // Save location to session storage for future use
            saveLocationToSession({ address, coordinates, metropolitan_area });

            // Debug logging
            logger.log("🏠 Layout-home setAddress called with:", {
              address,
              coordinates,
              metropolitan_area
            });

            // Navigate to explore page with coordinates and metropolitan area
            const metropolitanAreaParam = metropolitan_area?.metropolitan_area
              ? `&metropolitan_area=${encodeURIComponent(metropolitan_area.metropolitan_area)}`
              : "";

            const finalURL = `/explore/chef?date=${selectedWhen}&lat=${coordinates.lat}&lng=${coordinates.lng}${metropolitanAreaParam}`;
            logger.log("🔗 Navigating to:", finalURL);

            return history.push(finalURL);
          }}
        />
        <SlideImage />
        <SectionWorking />
        <SectionMore />
      </div>
    </div>
  );
};

export default Layout;

const post_selected_when = (data) => ({
  type: POST_SELECTED_WHEN,
  data: data
});


